module.exports = __webpack_public_path__ + "img/12蒸洗罐.766f2d4d.jpg";